import {TemplateRef} from "@angular/core";
import {LabelChange, Transaction} from "@app/shared";

export class TableColumn {
  field?: string;
  header: string;
  tooltip?: string;
  columnStyle?: string;
  disableSortIcon?: boolean;

  subfield?: string;
  app?: TableApp;
  format?: TableFormat;
  headerTemplate?: TemplateRef<any>;
  template?: TemplateRef<any>;

  // format options
  labelChangeList?: LabelChange[];
  noTitleCaseList?: string[];
  refIdField?: string;
  boldField?: string;
  routeLink?: string;
  type?: string;
  postFix?: string;

  // template options
  transaction?: Transaction;
  currentStatus?: string;             // e.g. currentStatusName
}

export enum TableApp {
  None,                             // used to pass *ngIf="col.app"; don't remove this
  Expansion,
  ApprovalStatus,
  ClinInfo,
  ContractInfo,
  ProjectInfo,
  ModHistory
}

// if None is not added, then Date defaults to 0 in which case this statement will be false col.format === TableFormat.Date
export enum TableFormat {
  None,                             // used to pass *ngIf="col.format"; don't remove this
  BooleanAsReadOnlyCheckbox,
  BooleanAsReadOnlyInputSwitch,
  BooleanAsReadOnlyYesOrNo,
  BooleanAsWritableInputSwitch,
  CheckOrBanAndValue,
  Currency,
  CurrencyNegative,
  CurrencyBold,
  Date,
  MediumDate,
  NoTitleCase,
  Number,
  NumberBold,
  Percentage,
  NumberAsPercentage,
  Phone,
  PostFix,
  RouteLink,
  SsnMask,
  StringReplace,
  Time,
  TitleCase,
}
